import React from "react";

const ThemeContext = React.createContext({
  colors : {primary: "#0f0", secondary: "#000"},
  setColors: () => {}
});

export default ThemeContext;